module.exports = __webpack_public_path__ + "static/media/bgi.7b25dffc.jpg";